<template>
    <div>
        <PageTitle :title="$t('gracias.title')" sectionClass="buy_success" />
        <FirstBanner />

        <section class="padding-vertical-content pt-0">
            <b-container>
                <ContentOrLoading :class="loading ? 'p-5' : ''">
                    <b-row class="justify-content-center mx-0 mx-sm-2 mx-md-4" v-if="!loading">
                        <b-col cols="12" lg="10">
                            <div class="text-center">
                                <p class="h4 mt-2 mt-lg-0">
                                    {{ $t('gracias.compra_confirmada') }}
                                </p>
                                <div class="d-flex justify-content-center">
                                    <p class="mr-2 mt-1">
                                        {{ $t("gracias.n_pedido") }}:
                                    </p>
                                    <h4 id="n-pedido" data-cy="n-pedido">
                                        {{ n_pedido }}
                                    </h4>
                                </div>
                            </div>
                            <div class="text-center mb-4">
                                <router-link :to="{ name: 'front.home' }" class="button button effect-button mt-0">
                                    <span>{{ $t("gracias.volver") }}</span>
                                </router-link>

                                <div class="h5" v-if="configuracion.aviso_gracias" v-html="configuracion.aviso_gracias"></div>
                            </div>

                            <div v-if="resumen.tipo === 'eventos'">
                                <DatosEntrada
                                    v-for="(entrada, index) in resumen.entradas"
                                    :key="index"
                                    :index="index"
                                    :entrada="entrada"
                                    :resumen="resumen"
                                    :sesion_fecha="resumen.sesion.fecha_inicio"
                                />
                            </div>
                            <div v-else>
                                <DatosAbono
                                    v-for="(abono, index) in resumen.abonados"
                                    :key="index"
                                    :abono="abono"
                                    :index="index"
                                />
                            </div>
                            <div v-if="resumen.tipo === 'eventos'" class="mt-2">
                                <p>
                                    <b>
                                        {{ $t('gracias.duda_incidencia', { email: manager.email_incidencias ? manager.email_incidencias : "info@compralaentrada.com" }) }}
                                    </b>
                                </p>
                                <p>
                                    <b>
                                        {{ $t('gracias.info_descarga_entradas') }}
                                    </b>
                                </p>
                            </div>
                        </b-col>
                    </b-row>
                </ContentOrLoading>
            </b-container>
        </section>
    </div>
</template>

<script>
    import PageTitle from "@/components/frontend/shared/PageTitle";
    import FirstBanner from "@/components/frontend/shared/FirstBanner";
    import DatosAbono from "@/components/frontend/sga/DatosAbono";
    import DatosEntrada from "@/components/frontend/sga/DatosEntrada";

    export default {
        props: {
            session_id: {
                type: String,
                required: true
            },
            n_pedido: {
                type: [Number, String],
                required: true
            }
        },
        data() {
            return {
                resumen: null,
                loading: false
            }
        },
        methods: {
            getResumen() {
                this.loading = true;

                const params = {
                    filters: {},
                    session_id: this.session_id,
                    tpv_order: this.n_pedido
                }

                this.$store.dispatch(this.config.getVuexAlias('sga.cart.resumen'), params).then(res => {
                    this.resumen = res.data.data;
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        created() {
            this.getResumen();
        },
        components: {
            PageTitle, FirstBanner, DatosAbono, DatosEntrada
        }
    }
</script>